import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import LandPurposesDt from '@/services/dataTransferModules/landPurposesDt'

export default function useLandPurposes(params = {}) {
	const landPurposesDt = new LandPurposesDt()

	const { t: $t } = useI18n()

	const defaults = {
		fieldsCreating: {
			name: '',
		},
		fieldsToPatch: [
			'name',
		],
	}

	const {
		loadEntityFlags: flags,

		entities: landPurposes,
		getEntities: getLandPurposes,

		createEntity: createLandPurpose,

		entity: landPurpose,
		getEntity: getLandPurpose,

		entityPopup: landPurposePopup,
		getEntityPopup: getLandPurposePopup,

		entityPreview: landPurposePreview,
		getEntityPreview: getLandPurposePreview,

		patchEntity: patchLandPurpose,
		updateEntity: putLandPurpose,

		deleteEntity: deleteLandPurpose,
	} = useBlProviders(
		landPurposesDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error when loading target assignments of land plots'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error when creating a designated purpose for a land plot'),

				showErrorNotificationForLoadingOneEntity: true,
				errorNotificationTextForLoadingOneEntity: $t('Error when loading the intended purpose of the land plot'),

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error when editing the purpose of a land plot'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Error when deleting the intended purpose of a land plot'),
			},
			params,
		),
	)

	return {
		flags,
		landPurposes,
		landPurpose,
		landPurposePreview,
		landPurposePopup,
		defaults,

		getLandPurposes,
		getLandPurpose,
		getLandPurposePreview,
		getLandPurposePopup,
		createLandPurpose,
		putLandPurpose,
		patchLandPurpose,
		deleteLandPurpose,
	}
}
